import tzTable from "./src/tz-table.vue"
export default tzTable